import Image01 from "./Assets/assets/main/image21.png"
import Image02 from "./Assets/assets/main/image22.png"
import Image03 from "./Assets/assets/main/image23.png"
import Image04 from "./Assets/assets/main/image26.png"


export const data = [
    {
      id: 1,
      image:Image01,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 2,
      image:Image02,
      title: "Honor",
      price: 7300000,
      discount:2435000
    },
    {
      id: 3,
      image:Image03,
      title: "Смартфон Samsung A.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 4,
      image:Image04,
      title: "Смартфон Samsung C.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 5,
      image:Image03,
      title: "Iphone X",
      price: 7300000,
      discount:2435000
    },
    {
      id: 6,
      image:Image01,

      title: "Assus Rog",
      price: 7300000,
      discount:2435000
    },
    {
      id: 7,
      image:Image03,

      title: "Nokia 2200",
      price: 7300000,
      discount:2435000
    },
    {
      id: 8,
      image:Image02,

      title: "Xiomi mi mix Alfa",
      price: 3200000,
      discount:2435000
    },
    {
      id: 9,
      image:Image01,

      title: "Iphone 11 pro max",
      price: 1200000,
      discount:2435000
    },
    {
      id: 10,
      image:Image04,

      title: "Samsung s22 ultra",
      price: 1300000,
      discount:2435000
    },
    {
      id: 11,
      image:Image01,

      title: "Samsung NOTE 10+",
      price: 73000,
      discount:2435000
    },
    {
      id: 12,
      image:Image01,

      title: "Alcatel One touch",
      price: 7300000,
      discount:2435000
    },
    {
      id: 13,
      image:Image04,

      title: "Смартфон Samsung G.. mobile",
      price: 200000,
      discount:2435000
    },
    {
      id: 14,
      image:Image03,

      title: "Смартфон Samsung AA.. mobile",
      price: 72320,
      discount:2435000
    },
    {
      id: 15,
      image:Image01,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 16,
      image:Image04,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 17,
      image:Image02,
      title: "Смартфон Samsung GFA.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 18,
      image:Image02,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 19,
      image:Image04,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 20,
      image:Image03,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 21,
      image:Image01,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 22,
      image:Image04,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 23,
      image:Image02,
      title: "Смартфон Samsung GFA.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 24,
      image:Image02,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 25,
      image:Image04,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 26,
      image:Image03,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 28,
      image:Image04,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 29,
      image:Image03,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id:30,
      image:Image04,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 31,
      image:Image03,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 25,
      image:Image04,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 32,
      image:Image03,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 33,
      image:Image03,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 34,
      image:Image04,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 35,
      image:Image03,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 36,
      image:Image03,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 37,
      image:Image04,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 38,
      image:Image03,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 39,
      image:Image03,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 40,
      image:Image04,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    },
    {
      id: 41,
      image:Image03,
      title: "Смартфон Samsung G.. mobile",
      price: 7300000,
      discount:2435000
    }
    
  ]